import React from 'react';
import PropTypes from 'prop-types';
import InvestorLink from 'components/InvestorLink';
import FluidImage from 'components/FluidImage';
import Link from 'components/Models/Link/Link';
import Image from 'components/Models/Image/Image';
import './InvestorReport.scss';

const DOWNLOADABLE_EXTENSIONS = ['.zip'];

const InvestorReport = ({ title, year, links, image }) => {
    return (
        <div className="investor-report">
            {/* BE: Image recommended size is 556x726px */}
            {image && (
                <div className="investor-report__cover-image-holder">
                    <FluidImage
                        className="investor-report__cover-image"
                        image={image.url}
                        altText={image.altText}
                        visible={true}
                    />
                </div>
            )}
            <div className="investor-report__top-info">
                {title && <h2 className="investor-report__title">{title}</h2>}
                {year && <span className="investor-report__year">{year}</span>}
            </div>
            {links && links.length > 0 ? (
                <div className="investor-report__links">
                    {links.map((link, index) => {
                        const isDownloadable = link.url && DOWNLOADABLE_EXTENSIONS.some(ext => link.url.indexOf(ext) > -1);

                        return (
                            <div className="investor-report__link-holder" key={index}>
                                <InvestorLink 
                                    {...link}
                                    leftIconName={isDownloadable ? "download" : null}
                                    iconName={isDownloadable ? null : "arrow-line-right"}
                                    className="investor-report__link"
                                    download={isDownloadable}
                                    openInNewWindow={!isDownloadable}
                                />
                            </div>
                        );
                    })}
                </div>
            ) : null}
        </div>
    );
};

InvestorReport.propTypes = {
    title: PropTypes.string,
    year: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.shape(Link.propTypes)),
    image: PropTypes.shape(Image.propTypes),
};

export default InvestorReport;



// WEBPACK FOOTER //
// ./src/components/InvestorReport/InvestorReport.jsx